import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import "../../assets//styles/local/ConfirmPurchasingOrder.css";
import EuropeanInput from "../../utils/European-Format/EuropeanInput";
import WarehouseIcon from "../../assets/icons/Warehouse.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import searchIcon from "../../assets/icons/search.svg";
import CheckboxBlueIcon from "../../assets/images/CheckboxBlue.svg";
import CheckboxIcon from "../../assets/images/CheckboxWhite.svg";
import PlusIcon from "../../assets/images/Plus.svg";
import Header from "../../layouts/Header";
import {
  AddItemInExistingOrder,
  AddToWarehouse,
  FetchProductBysupplierid,
  FetchPurchasingOrder,
  FetchWarehousePurchasingOrder,
  UpdateOrderProductQty,
  ProjectDropdown,
  UpdateWarehouseOrderProject,
} from "../../redux/actions/action";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import AddMissingItems from "./AddMissingItems";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Package from "../../assets/icons/package.svg";
import bin from "../../assets/icons/Bin.svg";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import AddPurchaseOrderDocument from "./AddPurchaseOrderDocument";

const ConfirmPurchasingOrder = () => {
  const location = useLocation();
  const orderId = location?.state?.orderid;
  const dispatch = useDispatch();
  const { orderCode } = useParams();
  const history = useHistory();
  const [addMissingItems, setAddMissingItems] = useState(false);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [supplierName, setSuppliername] = useState("");
  const [projectName, setProjectName] = useState("");
  const [typeField, setTypeField] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [projectTableData, setProjectTableData] = useState([]);
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";
  const [supplierId, setSupplierId] = useState("");
  const [selectedProject, setsSelectedProject] = useState(null);
  const [projectId, setProjectId] = useState("");
  console.log("asc67", projectId);
  const fetchPurchasingOrderData = useSelector(
    (state) => state.user.fetchPurchasingOrder,
  );
  const fetchProductBySupplierIdList = useSelector(
    (state) => state.user.fetchProductBySupplierId,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const fetchProjectDropdownData = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );

  const updateWareHouseProjectRes = useSelector(
    (state) => state.user.updateWareHouseProjectRes,
  );

  useEffect(() => {
    fetchScreenTranslations("Add To Warehouse And Assign To Project").then(
      (data) => setFetchTranslationList(data),
    );
    dispatch(ProjectDropdown());
  }, []);

  useEffect(() => {
    if (fetchProjectDropdownData != null) {
      if (fetchProjectDropdownData?.status) {
        setProjectTableData(fetchProjectDropdownData?.data);
      }
    }
  }, [fetchProjectDropdownData]);

  useEffect(() => {
    if (supplierId) {
      dispatch(FetchProductBysupplierid(supplierId));
    }
  }, [dispatch, supplierId]);

  const [stockData, setStockData] = useState([]);

  useEffect(() => {
    if (
      fetchProductBySupplierIdList != null &&
      fetchProductBySupplierIdList?.status
    ) {
      setStockData(fetchProductBySupplierIdList?.data);
      setSearchedData(fetchProductBySupplierIdList?.data);
    }
  }, [fetchProductBySupplierIdList]);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (orderId) {
      dispatch(FetchPurchasingOrder(orderId));
    }
  }, [dispatch, orderId]);

  useEffect(() => {
    if (fetchPurchasingOrderData != null && fetchPurchasingOrderData?.status) {
      setTableData(fetchPurchasingOrderData?.data[0]?.orderproduct);
      setSuppliername(fetchPurchasingOrderData?.data[0]?.suppliername);
      setProjectName(fetchPurchasingOrderData?.data[0]?.projectname);
      setProjectId(fetchPurchasingOrderData?.data[0]?.projectid);
      setSupplierId(fetchPurchasingOrderData?.data[0]?.supplierid);
    }
  }, [fetchPurchasingOrderData]);

  const handleSelectAllChange = () => {
    const updatedData = tableData.map((item) => {
      // Only update items with ischeck !== 1
      if (item.ischeck !== 1) {
        return {
          ...item,
          isChecked: !selectAllChecked,
        };
      }
      return item;
    });
    setTableData(updatedData);
    setSelectAllChecked(!selectAllChecked);
    setTypeField("asc");
  };

  const handleCheckboxChange = (orderproductid) => {
    const updatedData = tableData.map((item) => {
      if (item.orderproductid === orderproductid) {
        return { ...item, isChecked: !item.isChecked };
      }
      return item;
    });
    setTableData(updatedData);
    const isAllChecked = updatedData
      .filter((item) => item.ischeck !== 1)
      .every((item) => item.isChecked);
    setSelectAllChecked(isAllChecked);
    setTypeField("asc");
  };

  const handleCheckboxChangeMissing = (ICitem) => {
    const updatedData = stockData.map((item) =>
      item.productPartid === ICitem.productPartid
        ? { ...item, isChecked: !item.isChecked }
        : item,
    );
    setStockData(updatedData);
    const orderProductsData = updatedData
      ?.filter((val) => val.isChecked)
      .map((item) => ({
        productid: item.productPartid,
        orderproductqty: "0",
      }));
    const payload = {
      orderid: orderId,
      orderproducts: orderProductsData,
    };
    dispatch(AddItemInExistingOrder(payload));
    setOpenAddItem(!openAddItem);
    setAddMissingItems(!addMissingItems);
    setTimeout(() => {
      dispatch(FetchPurchasingOrder(orderId));
      setStockData(stockData);
    }, 2000);
    setShowAddMissingModal(false);
  };

  const AddItemsFun = async () => {
    let updatedData = tableData;
    if (screenSize === "xs" || isOrderPicking) {
      updatedData = tableData.map((item) => {
        if (item.ischeck !== 1) {
          return {
            ...item,
            isChecked: !selectAllChecked,
          };
        }
        return item;
      });
      setTableData(updatedData);
    }
    if (updatedData.some((val) => val.isChecked === true)) {
      const warehouseProductData = updatedData
        ?.filter((val) => val.isChecked)
        .map((item) => ({
          productid: item.productid,
          orderproductid: item.orderproductid,
        }));

      const payload = {
        supplierid: supplierId,
        orderId: orderId,
        warehouseproduct: warehouseProductData,
      };
      dispatch(AddToWarehouse(payload));
      dispatch(UpdateWarehouseOrderProject(orderId, projectId));
      if (screenSize !== "xs" && !isOrderPicking) {
        await handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "Great Job! The purchase order was added to the warehouse.",
          },
          false,
        );
      }

      const orderProductQtyData = updatedData.map((item) => ({
        orderproductid: item.orderproductid,
        orderproductqty: item.orderproductqty.toString(),
      }));

      const payload1 = {
        orderproductqty: orderProductQtyData,
      };
      await dispatch(UpdateOrderProductQty(payload1));
      setTimeout(() => {
        dispatch(FetchWarehousePurchasingOrder(10, 1, ""));
      }, 1000);
      if (screenSize === "xs" || isOrderPicking) {
        setShowConfirmationModal(true);
      } else {
        history.goBack();
      }
    }
  };
  const handleClose = () => setModalShow(false);
  const updateQtyFuc = (val, orderproductid) => {
    const changeQty = tableData.map((item) =>
      item.orderproductid === orderproductid
        ? { ...item, orderproductqty: val }
        : item,
    );
    setTableData(changeQty);
  };
  const screenSize = useScreenSize();
  const [showProjectsModal, setShowProjectsModal] = useState(false);
  const [showAddMissingModal, setShowAddMissingModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [searchMissing, setSearchMissing] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);
  useEffect(() => {
    if (tableData && tableData?.length) {
      const totalAr = tableData.map((item) => {
        const productCost = parseInt(item?.productcost, 10);
        const orderProductQty = parseInt(item?.orderproductqty, 10);
        if (!isNaN(productCost) && !isNaN(orderProductQty)) {
          return productCost * orderProductQty;
        } else {
          return 0;
        }
      });
      const sum = totalAr.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
      }, 0);
      setTotal(sum);
    }
    return () => {
      setTotal(0);
    };
  }, [tableData]);

  useEffect(() => {
    if (searchMissing !== "") {
      let searchedData = stockData.filter((s) =>
        s.productpartname.toLowerCase().includes(searchMissing.toLowerCase()),
      );
      setSearchedData(searchedData);
    } else setSearchedData(stockData);
  }, [searchMissing]);

  const handleCancel = () => {
    history.goBack();
  };
  return (
    <>
      <Header
        leftComponent={
          <div className="stock-heading-box">
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <div className="confirm-box-title">
              <div className="opacity-1">
                {/* Purchasing Order */}
                {t("Purchasing Order")}
              </div>
              <div className="stock-order-id">ID {orderCode}</div>
            </div>
          </div>
        }
      />
      {modalShow && (
        <CancelWarningModal
          show={modalShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeField !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeField !== "") {
            if (!["/add-to-warehouse-project"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />

      <div className="container-fluid main-wrapper mb-4">
        {screenSize === "xs" || isOrderPicking ? (
          <>
            <div
              style={{
                display: "flex",
                // gap: "10px",
                // justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", gap: "1px" }}>
                <div
                  style={{
                    color: "#7F7E7F",
                    fontWeight: "bolder",
                    fontSize: "1.1rem",
                    marginTop: "10px",
                    marginBottom: "25px",
                    paddingLeft: "10px",
                  }}
                  onClick={() => {
                    history.push("/stock");
                  }}
                >
                  {/* Stock */}
                  {t("Stock")}
                </div>
                <img
                  alt=""
                  src={Downarrow}
                  style={{
                    opacity: "60%",
                    marginTop: "18px",
                    marginBottom: "15px",
                    width: "15px",
                    height: "12px",
                    transform: "rotate(90deg)",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    history.goBack();
                  }}
                />
              </div>
              <div style={{ display: "flex", gap: "1px", marginRight: "20px" }}>
                <img
                  alt=""
                  className="me-1"
                  src={WarehouseIcon}
                  style={{
                    fontSize: "1.1rem",
                    marginTop: "11px",
                    marginBottom: "15px",
                    width: "15px",
                    height: "24px",
                    transform: "rotate(0deg)",
                    cursor: "pointer",
                  }}
                />
                <div
                  style={{
                    color: "#7F7E7F",
                    fontWeight: "bolder",
                    fontSize: "1rem",
                    marginTop: "12px",
                    marginBottom: "15px",
                  }}
                >
                  {/* Add to Warehouse */}
                  {t("Add to warehouse")}
                </div>
              </div>
            </div>

            <div className="ps-2" style={{ paddingBottom: "20px" }}>
              <AddPurchaseOrderDocument
                // poOrderCode={poOrderCode}
                orderid={orderId}
                isDisabled={true}
              />
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              className="btn addParchCancel me-4"
              onClick={() => {
                if (typeField !== "") {
                  setModalShow(true);
                } else {
                  history.goBack();
                }
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="btn addParchAdd add-btn-disable"
              style={{ fontSize: "14px" }}
              onClick={AddItemsFun}
              disabled={!tableData.some((val) => val.isChecked === true)}
            >
              {/* Add */}
              {t("Add")}
            </button>
          </div>
        )}
        {screenSize === "xs" || isOrderPicking ? (
          <div className="d-flex flex-column" style={{ marginBottom: "150px" }}>
            <p
              className="margin-0-pop  ps-2"
              style={{ fontWeight: "600", fontSize: "medium" }}
            >
              {/* Supplier */}
              {t("Supplier")}
            </p>

            <div
              className="project-drop-view d-flex"
              style={{ marginTop: "10px", justifyContent: "flex-start" }}
            >
              <p className="margin-0-pop  ps-2">{supplierName}</p>
            </div>
            <p
              className="margin-0-pop  ps-2"
              style={{
                marginTop: "20px",
                fontWeight: "600",
                fontSize: "medium",
              }}
            >
              {/* Project */}
              {t("Project")}
            </p>

            <div
              onClick={() => setShowProjectsModal(true)}
              className="project-drop-view d-flex"
              style={{ marginTop: "10px", justifyContent: "flex-start" }}
            >
              <p className="margin-0-pop  ps-2">{projectName}</p>
            </div>

            <div
              style={{
                marginTop: "30px",
                marginLeft: "20px",
                marginRight: "20px",
                paddingBottom: "20px",
                borderBottom: "1px dotted",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ opacity: "50%" }}>Item</p>

                <p style={{ opacity: "50%" }} className="me-3">
                  {/* Qty */}
                  {t("Qty")}
                </p>
              </div>
              {tableData?.map((item, index) => {
                return (
                  <div
                    key={`tbl-row-${index}`}
                    style={{
                      display: "flex",
                      backgroundColor: `${item.ischeck ? "#FAFAFA" : ""}`,
                      marginBottom: "15px",
                      alignItems: "baseline",
                    }}
                  >
                    <p className="product-des" style={{ wordWrap: "anywhere" }}>
                      {item.productname}
                    </p>

                    <p
                      className="product-de-s"
                      style={{ textAlign: "end", fontWeight: "bold" }}
                    >
                      <EuropeanInput
                        style={{
                          backgroundColor: `${item.ischeck ? "#FAFAFA" : ""}`,
                          textAlign: "end",
                          fontWeight: "bold",
                          width: "60px",
                        }}
                        className="purchSupplierCode-mobile text-end-0 ps-2 qty-data"
                        hidePreview={true}
                        value={item.orderproductqty}
                        onChange={(val) => {
                          updateQtyFuc(val, item.orderproductid);
                        }}
                        withoutSymbol={true}
                        readOnly={item.ischeck}
                      />
                    </p>
                    <img
                      src={bin}
                      alt=""
                      width={15}
                      height={12}
                      className="ms-2 text-end invisible"
                    />
                  </div>
                );
              })}
              <div
                onClick={() => setShowAddMissingModal(true)}
                className="project-drop-view d-flex"
                style={{ marginTop: "10px", justifyContent: "flex-start" }}
              >
                <p className="margin-0-pop  ps-2">
                  {/* Add missing item */}
                  {t("Add missing item")}
                </p>
              </div>
            </div>

            <tr style={{ backgroundColor: "#FAFAFA", padding: "20px" }}>
              <td
                className="product-des"
                style={{ paddingLeft: "20px", fontWeight: "bold" }}
              >
                Total
              </td>

              <td
                className="product-des"
                style={{ textAlign: "end", fontWeight: "bold" }}
              >
                € {total}
              </td>
            </tr>

            {tableData.length === 0 && (
              <div className="nodata-found">No data found ..</div>
            )}
            <div
              style={{
                position: "fixed",
                bottom: "0",
                paddingBottom: "15px",
                width: "100%",
                background: "#fafafa",
                paddingLeft: "20px",
                zIndex: "1053",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <button
                  type="button"
                  className="btn addParchCancel me-4"
                  style={{ width: "85%" }}
                  onClick={() => {
                    if (typeField !== "") {
                      setModalShow(true);
                    } else {
                      history.goBack();
                    }
                  }}
                >
                  {/* Cancel */}
                  {t("Cancel")}
                </button>
                <button
                  type="button"
                  style={{ width: "85%" }}
                  className="btn addParchAdd add-btn-disable"
                  onClick={() => {
                    AddItemsFun();
                  }}
                  // disabled={!tableData.some((val) => val.isChecked === true)}
                >
                  {/* Add */}
                  {t("Add")}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="confirm-table-wrapper  position-relative"
            style={{ height: `${openAddItem ? "100vh" : ""}` }}
          >
            <div className="d-flex align-items-center justify-content-between confirm-table-sub">
              <div className="d-flex align-items-center">
                <div className="asc-input-container" id="ascInput">
                  <label className="asc-label-top ClientNameText small-titl-e">
                    {/* Supplier */}
                    {t("Supplier")}
                  </label>
                  <p
                    className="asc_NormalInput mb-0 p-3"
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#323232",
                      background: "white",
                    }}
                  >
                    {supplierName}
                  </p>
                </div>
              </div>

              <div
                className="d-flex align-items-center pointer"
                onClick={() => setShowProjectsModal(true)}
              >
                <div className="asc-input-container" id="ascInput">
                  <label className="asc-label-top ClientNameText small-titl-e">
                    {/* Project */}
                    {t("Project")}
                  </label>
                  <p
                    className="asc_NormalInput mb-0 p-3 small-title-des"
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#323232",
                      background: "white",
                    }}
                  >
                    {projectName ? projectName : "Select a Project"}
                  </p>
                </div>
              </div>

              <div className="ps-2" style={{ paddingTop: "25px" }}>
                <AddPurchaseOrderDocument
                  // poOrderCode={poOrderCode}
                  orderid={orderId}
                  isDisabled={true}
                />
              </div>

              <div
                className="d-flex align-items-center gap-3 pt-3 cursor-pointer"
                onClick={() => setAddMissingItems(!addMissingItems)}
              >
                <img className="plus-img" src={PlusIcon} alt="plus" />
                <div className="add-warehouse">
                  {/* Add missing item */}
                  {t("Add missing item")}
                </div>
              </div>
            </div>
            <table className="table stock-confirm-add-table">
              <thead>
                <tr>
                  {isBuildingBlock && <th className="suppler-code"></th>}
                  <th className="product-des">
                    {/* Product Description */}
                    {t("Product Description")}
                  </th>
                  <th className="suppler-code" style={{ width: "30%" }}>
                    {/* Supplier Code */}
                    {t("Supplier Code")}
                  </th>
                  <th className="d-flex justify-content-center">
                    {/* Color */}
                    {t("Color")}
                  </th>
                  <th className="color-td">
                    {/* Qty */}
                    {t("Qty")}
                  </th>
                  <th
                    className="confirm-items cursor-pointer"
                    onClick={handleSelectAllChange}
                  >
                    {/* Confirm All */}
                    {t("Confirm All")}
                    <img
                      className="plus-img"
                      src={selectAllChecked ? CheckboxBlueIcon : CheckboxIcon}
                      alt="check-item"
                    />
                  </th>
                </tr>
              </thead>
              <tbody className="border-0">
                {addMissingItems && (
                  <tr>
                    <td
                      className="suppler-code cursor-pointer"
                      onClick={() => {
                        setOpenAddItem(!openAddItem);
                      }}
                    >
                      Type an item
                    </td>
                  </tr>
                )}
                {tableData.map((item, index) => {
                  return (
                    <tr
                      key={`tbl-row-${index}`}
                      style={{
                        backgroundColor: `${item.ischeck ? "#FAFAFA" : ""}`,
                      }}
                    >
                      {isBuildingBlock && (
                        <td className="title-hover">
                          <div className="items-desc-column2">
                            <div className="desc-image-wrp2 desc-image2 ">
                              {item.coverimage ? (
                                <>
                                  <div
                                    className={`product-list-image-default2 ${
                                      item.image.length === 0
                                        ? "hover-hide2"
                                        : ""
                                    }`}
                                  >
                                    <img
                                      src={item.coverimage}
                                      alt=""
                                      className="cover-image2"
                                    />
                                    {item.image && item.image.length > 0 && (
                                      <div className="image-row2">
                                        {item.image
                                          .slice(0, 3)
                                          .map((val, index) => (
                                            <img
                                              key={index}
                                              src={val}
                                              alt={`Images ${index + 1}`}
                                            />
                                          ))}
                                      </div>
                                    )}
                                  </div>
                                  {item.image && item.image.length > 0 && (
                                    <span className="desc-image-plus2">
                                      <Image
                                        height={10}
                                        width={10}
                                        src={plusBorderWhite}
                                      />
                                    </span>
                                  )}
                                </>
                              ) : (
                                <div className="product-list-default2">
                                  <img
                                    src={Package}
                                    alt=""
                                    className="default-img2"
                                  />
                                  <div className="product-image-title">
                                    Picture
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                      )}
                      <td className="product-des pt-4">{item.productname}</td>
                      <td className="suppler-code pt-">
                        <img
                          src={item?.barCode}
                          alt=""
                          style={{ width: "100%", height: "80px" }}
                        />
                        <br />
                        {/* {item.suppliercode} */}
                      </td>
                      <td className="">
                        {item.productcolor && (
                          <div
                            style={{ backgroundColor: `${item.productcolor}` }}
                            className="color-code mt-4 m-auto"
                          ></div>
                        )}
                      </td>
                      <td className="color-td pt-4">
                        <EuropeanInput
                          style={{
                            backgroundColor: `${item.ischeck ? "#FAFAFA" : ""}`,
                          }}
                          className="purchSupplierCode text-center ps-2 qty-data"
                          hidePreview={true}
                          value={item.orderproductqty}
                          onChange={(val) => {
                            setTypeField("asc");
                            updateQtyFuc(val, item.orderproductid);
                          }}
                          withoutSymbol={true}
                          readOnly={item.ischeck}
                        />
                      </td>
                      <td className="d-flex justify-content-end pt-4">
                        {item.ischeck ? (
                          <img
                            className="plus-img-disable"
                            src={CheckboxIcon}
                            alt="check-item"
                          />
                        ) : (
                          <img
                            className="plus-img"
                            onClick={() =>
                              handleCheckboxChange(item.orderproductid)
                            }
                            src={
                              item.isChecked ? CheckboxBlueIcon : CheckboxIcon
                            }
                            alt="check-item"
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {tableData.length === 0 && (
              <div className="nodata-found">No data found ..</div>
            )}
            {openAddItem && (
              <AddMissingItems
                setOpenAddItem={setOpenAddItem}
                openAddItem={openAddItem}
                suppliersId={supplierId}
                addMissingItems={addMissingItems}
                setAddMissingItems={setAddMissingItems}
              />
            )}
          </div>
        )}
      </div>
      {showProjectsModal && (
        <div
          className="wt-modal-background-mobile"
          style={{ overflow: "unset" }}
        >
          <div
            className={
              screenSize === "xs" || isOrderPicking
                ? "wt-mdoal-div-mobile mx-"
                : "wt-mdoal-div-web"
            }
          >
            <section
              className="wt-modal-top-sec-mobile"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <p className="wt-modal-top-text">Select a Project</p>
              <img
                src={Xicon}
                alt=""
                className="pointer"
                style={{ width: "12px" }}
                onClick={() => setShowProjectsModal(false)}
              />
            </section>
            <div
              style={{
                // marginLeft: "20px",
                // marginRight: "20px",
                overflow: "auto",
              }}
            >
              {projectTableData?.map((project) => {
                return (
                  <div
                    className="ulterDrop"
                    onClick={() => {
                      setProjectName(project.projectname);
                      setProjectId(project.projectid);
                      setShowProjectsModal(false);
                      setTypeField("asc");
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {(screenSize === "xs" || isOrderPicking) && (
                      <Image
                        variant="top"
                        style={{
                          border: "6px solid white",
                          borderRadius: "10px",
                        }}
                        className="teammemberphoto mt-0"
                        src={project?.cover}
                      />
                    )}

                    <p
                      className="margin-0-pop p-2"
                      style={{ fontWeight: "500" }}
                    >
                      {project?.projectcode}&nbsp;┃&nbsp;
                      {project.projectname}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {showAddMissingModal && (
        <div className="wt-modal-background-mobile">
          <div className="wt-mdoal-div-mobile">
            <div
              className="wt-modal-top-sec-mobile"
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "35px",
                paddingRight: "35px",
              }}
            >
              <p className="" style={{ fontWeight: "bold" }}>
                Choose an item
              </p>
              <AiOutlineCloseCircle
                size={25.54}
                color="#333333"
                onClick={() => {
                  setShowAddMissingModal(false);
                }}
              />
            </div>
            <div style={{ marginRight: "25px", marginLeft: "25px" }}>
              <div className="project-search-main-mobile">
                <img className="search_pop ms-2 mb-1" src={searchIcon} />
                <input
                  type="text"
                  value={searchMissing}
                  style={{
                    margin: "0 0 0 0.5rem",
                    fontSie: "14px",
                  }}
                  placeholder="Search"
                  className="search-style select-client-div"
                  onChange={(e) => {
                    setSearchMissing(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              style={{
                marginLeft: "30px",
                marginRight: "30px",
                overflow: "auto",
                marginTop: "20px",
              }}
            >
              {searchedData?.map((item) => {
                return (
                  <div
                    onClick={() => handleCheckboxChangeMissing(item)}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "space-betwee-n",
                      gap: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      className="margin-0-pop  ps-2"
                      style={{ fontWeight: "600", minWidth: "145px" }}
                    >
                      {item.itemid}
                    </p>
                    <p
                      className="margin-0-pop  ps-2"
                      style={{ fontWeight: "6 00" }}
                    >
                      {item.productpartname}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {showConfirmationModal && (
        <div className="wt-modal-background-mobile">
          <div className="confirmation-modal-div-mobile">
            <div
              style={{
                marginRight: "80px",
                marginLeft: "80px",
                color: "white",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                alignItems: "center",
                height: "60vh",
              }}
            >
              <p>
                The purchasing order was successfully added to the warehouse and
                assigned to the project.
              </p>
              <p style={{ fontWeight: "700" }}>
                Do you want to add another purchasing order to the warehouse.
              </p>
            </div>
            <div
              style={{
                gap: "10px",
                width: "100%",
                position: "fixed",
                bottom: 30,
                left: 0,
                right: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                style={{
                  width: "80%",
                  height: "60px",
                  border: "1px solid white",
                  background: "#01246B",
                  fontWeight: "900",
                  color: "white",
                }}
                className="btn addParchCancel"
                onClick={() => {
                  history.push("/stock");
                }}
              >
                No
              </button>
              <button
                type="button"
                className="btn addParchCancel"
                style={{
                  width: "80%",
                  height: "60px",
                  fontWeight: "900",
                  color: "#01246B",
                }}
                onClick={() => {
                  history.goBack();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmPurchasingOrder;
